module.exports = __webpack_public_path__ + "static/media/cryptocoins.b458578c.woff2";